<template>
	<div>
		<div class="breadcrumb">
	    	<h1 style="color: #AC8400;">Transactions</h1>
		</div>
	    
	    <div class="separator-breadcrumb border-top"></div>
	        <div class="row mb-4">
	            <div class="col-md-12 mb-4">
	            	
	            	<!-- New -->
	            	<div class="card text-left">
	                    <div class="card-body">
	                        <h4 class="card-title mb-3">
                            <div class="row">
                              <div class="col-md-2">
                                Status 
                              </div>
                              <div class="col-md-4">
                                <select class="form-control">
                                    <option>All</option>
                                    <option>New</option>
                                    <option>In Process</option>
                                    <option>Completed</option>
                                </select>
                                </div>
                              </div>

                          </h4>
	                        <p>The table below shows the list of all transactions.</p>
	                        <div class="table-responsive">
	                            <table id="new_transaction" class="display table table-striped table-bordered" style="width:100%; text-align: left;">
	                                <thead>
	                                    <tr>
	                                        <th>No.</th>
	                                        <th>Status</th>
	                                        <th>Customer Name</th>
	                                        <th>Scheme</th>
	                                        <th>Description</th>
	                                        <th>Datetime</th>
	                                        <th>Amount</th>
	                                    </tr>
	                                </thead>
	                                <tbody>
	                                    <tr>
	                                        <td>1</td>
	                                        <td><button type="button" class="btn btn-success btn-rounded m-1" style="width: 150px; background-color: #AC8400; border-color: #AC8400;">Completed</button></td>
	                                        <td>John Doe</td>
	                                        <td>Musafir</td>
	                                        <td>
<b>Certificate Number:</b> MSF/0000121/19/TEL              <br/>
<b>Plan:</b> Individual Firdaus Plan (Worldwide)           <br/>
<b>Takaful Period:</b> 15/03/2019 - 11/04/2019 (28 Days)   <br/>
<b>Participant Name:</b> John Doe            <br/>

<br/>

<b>Certificate Number:</b> MSF/0000122/19/TEL              <br/>
<b>Plan:</b> Individual Firdaus Plan (Worldwide)           <br/>
<b>Takaful Period:</b> 15/03/2019 - 11/04/2019 (28 Days)   <br/>
<b>Participant Name:</b> Jane doe    
</td>
	                                        <td>10.30am<br/>06 February 2019</td>
                                          <td>$150.00</td>
	                                    </tr>
	                                    <tr>
	                                        <td>2</td>
<td><button type="button" class="btn btn-success btn-rounded m-1" style="width: 150px; background-color: #CD853F; border-color: #CD853F;">In Process</button></td>
	                                        <td>Jane Doe</td>
	                                        <td>Musafir</td>
	                                        <td>

<b>Certificate Number:</b> MSF/0000122/19/TEL              <br/>
<b>Plan:</b> Individual Firdaus Plan (Worldwide)           <br/>
<b>Takaful Period:</b> 15/03/2019 - 11/04/2019 (28 Days)   <br/>
<b>Participant Name:</b> Jane doe    
</td>
	                                        <td>10.30am<br/>06 July 2019</td>
                                          <td>$150.00</td>
	                                    </tr>
	                                    <tr>
	                                        <td>3</td>
	                                        <td><button type="button" class="btn btn-success btn-rounded m-1" style="width: 150px; background-color: #CD853F; border-color: #CD853F;">In Process</button></td>
	                                        <td>John Doe</td>
	                                        <td>Musafir</td>
	                                        <td>
<b>Certificate Number:</b> MSF/0000121/19/TEL              <br/>
<b>Plan:</b> Individual Firdaus Plan (Worldwide)           <br/>
<b>Takaful Period:</b> 15/03/2019 - 11/04/2019 (28 Days)   <br/>
<b>Participant Name:</b> John Doe            

</td>
	                                        <td>10.30am<br/>06 February 2019</td>
                                          <td>$150.00</td>
	                                    </tr>
	                                    <tr>
	                                        <td>4</td>
	                                        <td><button type="button" class="btn btn-success btn-rounded m-1" style="width: 150px; background-color: 	#FFA500; border-color: 	#FAFAD2;">New</button></td>
	                                        <td>Jane Doe</td>
	                                        <td>Musafir</td>
	                                        <td>
<b>Certificate Number:</b> MSF/0000121/19/TEL              <br/>
<b>Plan:</b> Individual Firdaus Plan (Worldwide)           <br/>
<b>Takaful Period:</b> 15/03/2019 - 11/04/2019 (28 Days)   <br/>
<b>Participant Name:</b> John Doe            <br/>
</td>
	                                        <td>10.30am<br/>06 July 2019</td>
                                          <td>$150.00</td>
	                                    </tr>
	                                    <tr>
	                                        <td>5</td>
	                                        <td><button type="button" class="btn btn-success btn-rounded m-1" style="width: 150px; background-color: 	#FFA500; border-color: 	#FAFAD2;">New</button></td>
	                                        <td>John Doe</td>
	                                        <td>Musafir</td>
	                                       <td>

<b>Certificate Number:</b> MSF/0000122/19/TEL              <br/>
<b>Plan:</b> Individual Firdaus Plan (Worldwide)           <br/>
<b>Takaful Period:</b> 15/03/2019 - 11/04/2019 (28 Days)   <br/>
<b>Participant Name:</b> Jane doe    
</td>
	                                        <td>10.30am<br/>06 February 2019</td>
                                          <td>$150.00</td>
	                                    </tr>
	                                    <tr>
	                                        <td>6</td>
	                                        <td><button type="button" class="btn btn-success btn-rounded m-1" style="width: 150px; background-color: 	#FFA500; border-color: 	#FAFAD2;">New</button></td>

	                                        <td>Jane Doe</td>
	                                        <td>Musafir</td>
<td>
<b>Certificate Number:</b> MSF/0000122/19/TEL              <br/>
<b>Plan:</b> Individual Firdaus Plan (Worldwide)           <br/>
<b>Takaful Period:</b> 15/03/2019 - 11/04/2019 (28 Days)   <br/>
<b>Participant Name:</b> Jane doe    
</td>
	                                        <td>10.30am<br/>06 July 2019</td>
                                          <td>$150.00</td>
	                                    </tr>
	                                </tbody>
	                            </table>
	                        </div>
	                    </div>
	                </div>

	                <br />



	            </div>
	        </div>
	    </div>

	</div>
</template>
<script>
// @ is an alias to /src
import axios from "axios"
export default {
  name: "report",
  components: {
  },
  mounted() {

      $("#new_transaction").DataTable( {
        dom: 'Bfrtip',
        lengthMenu: [
            [ 10, 25, 50, -1 ],
            [ '10 rows', '25 rows', '50 rows', 'Show all' ]
        ],
        buttons: [
            'pageLength', 'colvis', 'csv', 'excel', 'pdf', 'print'
        ]
    });

    
    },
    methods:{
		
	}	
}
</script>